import React from 'react'

import { getBrandConfig } from '../../../config/brands'
import { AdvertiserLogo } from '../../../shared/assets'

const { brandConfig } = getBrandConfig()

export const Logo = () => <AdvertiserLogo h="30px" iconName={brandConfig.logo} size="m" w="196px" />
